export const channelList:any = {
  fbads: 'FACEBOOK',
  ggSearch: 'Google Search',
  ggDisplay: 'Google Display',
  ggpmax: 'Google Pmax',
  ggdis: 'Google Discovery',
  ytads: 'YouTube',
  yhSearch: 'Yahoo Search',
  twads: 'TWITTER',
  lineads: 'LINE',
  ttads: 'TIKTOK',
  a8net: 'A8net',
  naver: 'naver',
  lkads: 'linkedin'
}
